// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609020317/js/" + chunkId + "." + {"44":"8102e3bb","225":"9f2ab3a4","481":"569fbae9","486":"b75858ee","770":"68a8c548"}[chunkId] + ".0.9713033742769825.chunk.js";
};